import Axios from 'axios';

export function getRequest(){
    return Axios.create({ 'headers': { 'Cache-Control': 'no-cache' } });
}